export enum AtiraLinkCategoryType {
  PERSONAL = 'PERSONAL',
  CORPORATE = 'CORPORATE',
  BOTH = 'BOTH',
}
